import React from 'react';
import mainBG from '../../assets/EinführungMainBG.png';
import ellipseBG from '../../assets/EllipseBG.png';
import { useTranslation } from "react-i18next";
import OverviewMail from '../common/forms/overviewMail';

const OverViewStart = ({ nextClick, backClick }) => {
    const { t } = useTranslation();
    const isSmallScreen = window.innerHeight <= 600;

    return (
        <div style={{ background: `url(${mainBG})` }} className='h-screen !bg-cover !bg-no-repeat !bg-center flex flex-col justify-between'>
            <div className='flex justify-center items-center text-center py-8 px-4'>
                <h1 className='font-bold text-base text-[#0F32C0E5] italic'>
                    {t(`overview_title_super`)}!<br />{t(`introduction_title`)}
                </h1>
            </div>
            <div style={{ background: `url(${ellipseBG})` }} className='min-h-[75vh] !bg-cover !bg-no-repeat !bg-top relative flex justify-center items-center'>
                <div className={`relative ${isSmallScreen ? 'pt-12' : 'pt-20'} mx-auto w-full ${isSmallScreen ? 'max-w-[38rem]' : 'max-w-[36rem]'} flex flex-col justify-between h-full justify-self-center text-center md:px-0 px-4 pb-4`}>
                    <div>
                        <OverviewMail />

                    </div>

                    <div className={`${isSmallScreen ? 'pt-2' : 'pt-4'} flex md:flex-row flex-col-reverse gap-3`}>
                        <button className='w-full button_primary' onClick={backClick} >{t(`s-2-btn1`)}</button>
                        <button className='w-full button_secodry' onClick={nextClick} >{t(`s-2-btn2`)}</button>
                    </div>

                </div>
                {/* <div className={`relative ${isSmallScreen ? 'pt-12' : 'pt-20'} md:px-0 px-4 w-full max-w-[36rem] flex flex-col items-center text-center`}>
                    <OverviewMail />
                    <div className={`${isSmallScreen ? 'pt-2' : 'pt-10'} flex md:flex-row flex-col-reverse gap-4 w-full md:max-w-[20rem]`}>
                        <button className='w-full button_primary' onClick={backClick}>{t(`s-2-btn1`)}</button>
                        <button className='w-full button_secodry' onClick={nextClick}>{t(`s-2-btn2`)}</button>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default OverViewStart;
